import { render, staticRenderFns } from "./UcSuggestCompanyOption.yaml?vue&type=template&id=104f007b&component"
import script from "./UcSuggestCompanyOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestCompanyOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports